<template>
	<div class="toolbar">
	<v-toolbar color="white" height="64px" width="100%" style="z-index: 300;">
    <v-toolbar-title>
			<v-img src="/mantenimiento/img/logotipo-300x115.png" max-width="160px" max-height="64px"/>
		</v-toolbar-title>
    <v-spacer></v-spacer>
		<div style="width: 20px;"></div>
		<v-btn icon @click="logout" x-large>
      <v-icon size="40">mdi-power</v-icon>
    </v-btn>
	</v-toolbar>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	
	export default {
		data: () => ({
			responsive: false,
			responsiveInput: false
		}),

		computed: {
			...mapGetters(["authorized"]),
		},

		watch: {
			$route(val) {
				this.title = val.meta.name;
			}
		},

		mounted() {
			this.onResponsiveInverted();
			window.addEventListener("resize", this.onResponsiveInverted);
		},
		beforeDestroy() {
			window.removeEventListener("resize", this.onResponsiveInverted);
		},

		methods: {
			onResponsiveInverted() {
				if (window.innerWidth < 991) {
					this.responsive = true;
					this.responsiveInput = false;
				} else {
					this.responsive = false;
					this.responsiveInput = true;
				}
			},
			logout: function() {
				this.$store.dispatch("logout").then(() => {
					this.$router.push("/");
				});
			}
		}
	};
</script>

<style scoped>
	.font{
		font-weight: 400;
    font-family: Roboto,sans-serif!important;
	}
	.size-1{
		font-size: 2.125rem!important;
    line-height: 2.5rem;
    letter-spacing: .0073529412em!important;
	}

	.size-2{
		font-size: 3rem!important;
    line-height: 3.125rem;
    letter-spacing: normal!important;
	}

	.toolbar{
    position: fixed;
    width: 100% !important;
    z-index: 300;
	}
</style>